import { WeatherHurricaneIcon } from './WeatherHurricaneIcon';

/**
 * author: Michael Richins
 * id 880967C4-85F9-4953-A6D0-73C9370BC987
 * name weather-hurricane
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/weather-hurricane.svg
 * tags
 * - Weather 
 * - Nature 
 * - Agriculture 
 */
export const CycloneIcon = WeatherHurricaneIcon;
export default CycloneIcon